import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface FP632 {
  fp632_01: string;
  fp632_02: number;
  fp632_03: number;
  fp632_12: number;  // 碼數
  fp632_13: number;  // 重量
  fp632_14: string;  // 備註
  fp632_91: string;
  fp632_92: string | null;
  fp632_93: string;
}

export interface FP631 {
  fp631_01: string;
  fp631_02: number;  // 明細序號
  fp631_11: string;  // COLOR
  fp631_12: string;  // 缸號
  fp631_13: string;
  fp631_14: number;  // 總疋數
  fp631_15: number;  // 碼數
  fp631_16: number;  // 重量
  fp631_17: number;  // 顏色子明細數
  fp631_18: string;  // 備註
  fp631_91: string;
  fp631_92: string | null;
  fp631_93: string;
  sub_details?: Partial<FP632>[];
}

export interface FP630 {
  fp630_01: string;         // 送貨單號
  fp630_10: string;         // 出庫通知單號
  fp630_11: string | null;  // 日期
  fp630_12: number;         // 出貨別 (1=送外加工, 2=內銷出貨, 3=退回/退修)
  fp630_13: string;         // 產品規格
  fp630_14: string;         // 客戶代號
  fp630_15: number;         // 總項數
  fp630_16: string;         // 訂單號
  fp630_91: string;         // 修改人
  fp630_92: string | null;  // 修改時間
  fp630_93: string;         // 建立人
  details?: FP631[];
}

export interface ListResponse {
  data: FP630[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API Functions
// ============================================================

const BASE = '/api/pwp253';

export const pwp253Api = {
  list: async (page = 1, size = 20): Promise<ListResponse> => {
    const res = await apiClient.get(BASE, { params: { page, pageSize: size } });
    return res.data;
  },

  get: async (id: string): Promise<FP630> => {
    const res = await apiClient.get(`${BASE}/${id}`);
    return res.data;
  },

  create: async (master: Partial<FP630>, details: Partial<FP631>[]): Promise<FP630> => {
    const res = await apiClient.post(BASE, { master, details });
    return res.data;
  },

  update: async (id: string, master: Partial<FP630>, details: Partial<FP631>[]): Promise<FP630> => {
    const res = await apiClient.put(`${BASE}/${id}`, { master, details });
    return res.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`${BASE}/${id}`);
  },

  lookupCustomer: async (code: string): Promise<{ code: string; name: string }> => {
    if (!code) return { code: '', name: '' };
    const res = await apiClient.get(`${BASE}/lookup/customer`, { params: { code } });
    return res.data;
  },
};

export default pwp253Api;
